import {injectable} from "inversify";
import {HTTP_SERVICE_NAME, HttpService} from "../http/HttpService";
import {AppCtx} from "../../ioc/ApplicationContext";

export const WALLET_SERVICE_NAME = "walletService";

export interface WalletService {

    getBalanceV2(pokUserId: string | number, walletAccountCode: string): Promise<WalletBalanceResult>;

    getBalancesV2(pokUserId: string | number): Promise<PokWalletAccounts>;

    credit(request: WalletTransactionRequest): Promise<WalletBalanceResult>;

    debit(request: WalletTransactionRequest): Promise<WalletBalanceResult>;
}

@injectable()
export class WalletServiceImpl {

    http: HttpService;
    entityPath: string;

    constructor() {
        this.http = AppCtx.resolve<HttpService>(HTTP_SERVICE_NAME);
        this.entityPath = "/wallet";
    }

    getBalanceV2(pokUserId: string | number, walletAccountCode: string): Promise<WalletBalanceResult> {
        return this.http.doGet(this.entityPath + "/balance/" + pokUserId + "/" + walletAccountCode);
    }

    getBalancesV2(pokUserId: string | number): Promise<PokWalletAccounts> {
        return Promise.all([
            this.getBalanceV2(pokUserId, 'gc-main'),
            this.getBalanceV2(pokUserId, 'sc-main'),
            this.getBalanceV2(pokUserId, 'gc-vault'),
            this.getBalanceV2(pokUserId, 'sc-vault'),
        ]).then(results => {
            return {
                'gc-main': results[0],
                'sc-main': results[1],
                'gc-vault': results[2],
                'sc-vault': results[3],
            };
        });
    }

    credit(request: WalletTransactionRequest): Promise<WalletBalanceResult> {
        return this.http.doPost(this.entityPath + "/credit", request);
    }

    debit(request: WalletTransactionRequest): Promise<WalletBalanceResult> {
        return this.http.doPost(this.entityPath + "/debit", request);
    }
}

export interface PokWalletAccounts {
    'sc-main': WalletBalanceResult,
    'gc-main': WalletBalanceResult,
    'gc-vault': WalletBalanceResult,
    'sc-vault': WalletBalanceResult,
}

export interface WalletBalanceResult {
    walletBalance: string
    walletVersion: number
}

export interface WalletTransactionRequest {
    userId: number;
    accountType: string;
    amount: string;
    comment: string;
    reasonCode: string;
}


// WEBPACK FOOTER //
// ./src/app/service/admin/WalletService.ts